import type {EventWizardVenue} from '@Components/event-wizard/event-wizard-venue/event-wizard-venue.types';
import type {CoverPhoto} from '@Components/event-wizard/event-wizard-image-video/event-wizard-image-video.types';
import {isEventNameComplete} from '@Components/event-wizard/name-input/name-input.types';
import {isEventVenueComplete} from '@Components/event-wizard/event-wizard-venue/event-wizard-venue.types';
import type {OrganiserDetails} from '@Components/event-wizard/event-wizard-organisers/event-wizard-organisers.types';
import {useSocialMediaLinksValidations} from '@Components/social-media-profile-links/social-media-profile-links.hooks';
import {getDateTimeErrorType} from '@Components/event-wizard/event-wizard-date-time/event-wizard-date-time.helper';
import type {TimeZone} from 'timezones-list';
import type {SocialMediaProfileLinksMap} from '@Components/social-media-profile-links/social-media-profile-links.types';
import trim from 'lodash/trim';

export const isBasicSectionComplete = (title: string, venue: EventWizardVenue, startDateTime: Date, endDateTime: Date, timezone: TimeZone): boolean => {
  if (!isEventNameComplete(title)) {
    return false;
  }

  if (getDateTimeErrorType(startDateTime, endDateTime, timezone) !== null) {
    return false;
  }

  return isEventVenueComplete(venue);
};

export const isMediaSectionComplete = (desc: string, coverPhoto: CoverPhoto): boolean => {
  return isDescriptionSectionComplete(desc) && isCoverPhotoSectionComplete(coverPhoto);
};

export const isDescriptionSectionComplete = (desc: string): boolean => {
  const textContent = getDescriptionRawText(desc);
  return !!textContent.trim();
};

export const isCoverPhotoSectionComplete = (coverPhoto: CoverPhoto): boolean => {
  return coverPhoto.uploadedUrl !== undefined && coverPhoto.uploadedUrl !== '';
};

export const isOrganiserSectionComplete = (organiserDetails: OrganiserDetails): boolean => {
  return isOrganiserBasicInfoComplete(organiserDetails) && isOrganiserSocialSectionComplete(organiserDetails.socialMediaLinks);
};

const isOrganiserBasicInfoComplete = (organiserDetails: OrganiserDetails): boolean => {
  return !organiserDetails.profilePic || organiserDetails.profilePic === '' || trim(organiserDetails.name) !== '';
};

const isOrganiserSocialSectionComplete = (socialMediaLinks?: SocialMediaProfileLinksMap): boolean => {
  return socialMediaLinks ? useSocialMediaLinksValidations(socialMediaLinks).isValid : true;
};

const getDescriptionRawText = (desc: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(desc, 'text/html');
  return doc.body.textContent ?? '';
};
